import { useMemo } from 'react';
import { useStamp_Duty_CalculatorLazyQuery } from '../types/graphqlHelpers';

interface Band {
  __typename: string;
  upperBand?: number;
  type: string;
  rateAdditional: number;
  rate: number;
  order: number;
  name: string;
  lowerBand?: number;
  effectiveDate: string;
  dueAdditional: number;
  due: number;
}

export interface StampDutyCalculatorResult {
  __typename: string;
  name: string;
  totalDue: number;
  totalDueAdditional: number;
  bands: Band[];
}

export interface StampDutyCalculator {
  __typename: string;
  effectiveDate: string;
  price: number;
  nonUkResident: boolean;
  results: StampDutyCalculatorResult[];
}

interface RootObject {
  __typename: string;
  stampDuty: {
    stampDutyCalculator: StampDutyCalculator;
  };
}
interface UseStampDutyCalculatorReturn {
  stampDutyCalculatorResults?: RootObject;
  handleStampDutyCalculation: (effectiveDate, price, nonUkResident) => void;
  loading: boolean;
}

export const UseStampDutyCalculator = (): UseStampDutyCalculatorReturn => {
  // Hook to retrieve Autocomplete location values
  const [stampDutyCalculator, { data: stampDutyCalculatorData, loading }] = useStamp_Duty_CalculatorLazyQuery();

  // Handle Autocomplete
  const handleStampDutyCalculation = (effectiveDate, price, nonUkResident) =>
    stampDutyCalculator({ variables: { effectiveDate, price, nonUkResident } });

  return {
    stampDutyCalculatorResults: stampDutyCalculatorData,
    handleStampDutyCalculation,
    loading,
  };
};
